export const addTask = (task) => {
  return (dispatch, getState, { getFirebase }) => {
    const firestore = getFirebase().firestore();
    const authorId = getState().firebase.auth.uid;

    firestore
      .collection('tasks')
      .add({
        ...task,
        authorId: authorId,
        date: new Date()
      })
      .then(() => {
        dispatch({
          type: 'ADD_TASK',
          task
        });
      })
      .catch((err) => {
        dispatch({
          type: 'ADD_TASK_ERR',
          err
        });
      });
  };
};

export const removeTask = (task) => {
  return (dispatch, getState, { getFirebase }) => {
    const firestore = getFirebase().firestore();

    firestore
      .collection('tasks')
      .doc(task.id)
      .delete()
      .then(() => {
        dispatch({
          type: 'REMOVE_TASK'
        });
      })
      .catch((err) => {
        dispatch({
          type: 'REMOVE_TASK_ERR',
          err
        });
      });
  };
};

export const toggleChecked = (task, completionData) => {
  return (dispatch, getState, { getFirebase }) => {
    const firestore = getFirebase().firestore();

    firestore
      .collection('tasks')
      .doc(task.id)
      .update({
        ...completionData // Injecte checked, completedAt, et touchedByUser d'un coup
      })
      .then(() => {
        dispatch({
          type: 'TOGGLE_CHECKED',
          task
        });
      })
      .catch((err) => {
        dispatch({
          type: 'TOGGLE_CHECKED_ERR',
          err
        });
      });
  };
};

export const editTask = (
  task,
  newTodo,
  priority,
  newPriority,
  priorityColor,
  newPriorityColor,
  category,
  newCategory,
  categoryColor,
  newCategoryColor,
  detail,
  newDetail,
  rdvDate,
  newRdvDate,
  rdvTime,
  newRdvTime,
  newIsRecurrent,
  newRecurrenceType,
  newLastResetMonth,
  newChecked = false,
  newAutoClosed = false,
  newTouchedByUser = false,
  location,
  taskLocation 
) => {
  return (dispatch, getState, { getFirebase }) => {
    const firestore = getFirebase().firestore();

    firestore
      .collection('tasks')
      .doc(task.id)
      .set(
        {
          ...task,
          task: newTodo,
          priority: newPriority,
          priorityColor: newPriorityColor,
          category: newCategory,
          categoryColor: newCategoryColor,
          detail: newDetail,
          rdvDate: newRdvDate,
          rdvTime: newRdvTime,
          isRecurrent: newIsRecurrent !== undefined ? newIsRecurrent : (task.isRecurrent || false),
          recurrenceType: newRecurrenceType !== undefined ? newRecurrenceType : (task.recurrenceType || ''),
          lastResetMonth: newLastResetMonth !== undefined ? newLastResetMonth : (task.lastResetMonth || ''),
          checked: newChecked !== undefined ? newChecked : (task.checked || false),
          autoClosed: newAutoClosed !== undefined ? newAutoClosed : (task.autoClosed || false),
          touchedByUser: newTouchedByUser !== undefined ? newTouchedByUser : (task.touchedByUser || false),
          location: taskLocation || ''
        },
        {
          merge: true
        }
      )
      .then(() => {
        dispatch({
          type: 'EDIT_TASK',
          task
        });
      })
      .catch((err) => {
        dispatch({
          type: 'EDIT_TASK_ERR',
          err
        });
      });
  };
};

export const addColorPicker = (task) => {
  return (dispatch, getState, { getFirebase }) => {
    const firestore = getFirebase().firestore();

    firestore
      .collection('tasks')
      .doc(task.id)
      .set(
        {
          ...task,
          modalColorBcg: task.modalColorBcg,
          modalColorTitle: task.modalColorTitle,
          modalColorPara: task.modalColorPara,
          modalColorSpan: task.modalColorSpan,
          modalColorStatutRep: task.modalColorStatutRep,
          boxColorBcg: task.boxColorBcg
        },
        { merge: true }
      )
      .then(() => {
        dispatch({
          type: 'ADD_COLOR_PICKER',
          task
        });
      })
      .catch((err) => {
        dispatch({
          type: 'ADD_COLOR_PICKER_ERR',
          err
        });
      });
  };
};
